import toast from 'react-hot-toast';
import { useMessages } from '../../../hooks/useMessages';
import { deleteChat } from '../../../services/fetch-utils';
import { ChatMessages } from '../../../interfaces/userInterfaces';

interface SingleMessageProps {
  message: ChatMessages;
  myMessage: boolean;
}

export const SingleMessageDisplay: React.FC<SingleMessageProps> = ({ message, myMessage }) => {
  const { setMessageToEdit, setEditingMessage, pessimisticDeleteChatMessage } = useMessages();

  const handleDelete = (message: ChatMessages) => {
    if (message.id) {
      const deleteResponse = deleteChat(message.id)
        .catch((error) => console.log('AN ERROR OCCURED IN DELETE TREE', error))
        .then((res) => message.id && pessimisticDeleteChatMessage(message, res));
      // console.log('RESPONSE FROM DELETE: ', deleteResponse);

      toast.promise(deleteResponse, {
        loading: 'Just a moment while we DELETE your Message',
        success: 'Message successfully deleted',
        error: 'Oops! Something went wrong. Please try again',
      });
    }
  };

  return (
    <>
      <li
        className={myMessage ? 'message-bubble sent' : `message-bubble received`}
        key={message.id}
      >
        <blockquote>
          <p key={`message-${message?.id}`} onClick={() => setMessageToEdit(message)}>
            {message?.message}
          </p>
        </blockquote>
        {myMessage && (
          <span className="chat-message-controls">
            <img
              className="chat-message-control-icons"
              src="/edit-icon.png"
              style={{ width: '15px', marginLeft: '3px' }}
              onClick={() => {
                setMessageToEdit(message);
                setEditingMessage(true);
              }}
            ></img>
            <img
              className="chat-message-control-icons"
              src="/delete-icon.png"
              style={{ width: '15px', marginLeft: '3px' }}
              onClick={() => handleDelete(message)}
            ></img>
          </span>
        )}
      </li>
    </>
  );
};
